const SparkleIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/>
    </svg>
);

const PenIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="2" x2="22" y2="6"/>
        <path d="M7.5 20.5L19 9l-4-4L3.5 16.5 2 22z"/>
    </svg>
);

const CheckIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round"
         strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12"/>
    </svg>
);

const XIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round"
         strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
);

const IconBtn = ({children, onClick}) => (
    <button
        onClick={onClick}
        style={{
            background: "none", border: "none", padding: "4px",
            cursor: "pointer", display: "flex", alignItems: "center",
            color: "#9ca3af", borderRadius: "4px",
            transition: "color 0.15s",
        }}
        onMouseEnter={e => e.currentTarget.style.color = "#374151"}
        onMouseLeave={e => e.currentTarget.style.color = "#9ca3af"}
    >
        {children}
    </button>
);

function ActionButtons({onAI, onEdit, onValidate, onDelete}) {
    return (
        <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
            <IconBtn onClick={onAI}><SparkleIcon/></IconBtn>
            <IconBtn onClick={onEdit}><PenIcon/></IconBtn>
            <IconBtn onClick={onValidate}><CheckIcon/></IconBtn>
            <IconBtn onClick={onDelete}><XIcon/></IconBtn>
        </div>
    );
}

export default ActionButtons;
